import { render, staticRenderFns } from "./CardUsage.vue?vue&type=template&id=163468b9&scoped=true&"
import script from "./CardUsage.vue?vue&type=script&lang=js&"
export * from "./CardUsage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163468b9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('163468b9')) {
      api.createRecord('163468b9', component.options)
    } else {
      api.reload('163468b9', component.options)
    }
    module.hot.accept("./CardUsage.vue?vue&type=template&id=163468b9&scoped=true&", function () {
      api.rerender('163468b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/accountdashboard/CardUsage.vue"
export default component.exports